export default __webpack_public_path__ + "static/media/senseye.e09f94fb.png";